import __var_0__ from './main.js'; // eslint-disable-line id-length
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a value is a skew-centrosymmetric matrix.
*
* @module @stdlib/assert/is-skew-centrosymmetric-matrix
*
* @example
* var ctor = require( '@stdlib/ndarray/ctor' );
* var isSkewCentrosymmetricMatrix = require( '@stdlib/assert/is-skew-centrosymmetric-matrix' );
*
* var ndarray = ctor( 'generic', 2 );
*
* var arr = ndarray( [ 2, 1, -1, -2 ], [ 2, 2 ], [ 2, 1 ], 0, 'row-major' );
*
* var bool = isSkewCentrosymmetricMatrix( arr );
* // returns true
*
* bool = isSkewCentrosymmetricMatrix( [] );
* // returns false
*/

// MODULES //
var isSkewCentrosymmetricMatrix = __var_0__;


// EXPORTS //
export default isSkewCentrosymmetricMatrix;
